import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import CdrAnalytics from './EpikBoxes/EpikBoxDetails/CdrAnalytics';
import VoipMonActivityLogs from './EpikBoxes/EpikBoxDetails/CdrAnalytics/VoipMonActivityLogs';
import { Tooltip } from 'reactstrap';
import { ReactComponent as AnalyticsIcon3 } from '../Res/CDR/datagram_3.svg';
import { ReactComponent as AnalyticsIcon2 } from '../Res/CDR/datagram_2.svg';
import { ReactComponent as LoadingIcon} from '../Res/loadingSpinner.svg';
import { getPermissionForComponent } from '../utils/permissionsUtils';

import { getAnalayticsImage, downloadAnalayticsFile } from '../actions/EpikBoxes';

const CdrAnalyticsModal = 
  ({ isOpen, onCancel, headText, cdrs, isCdrLogs, cdrVoipMonLogs }) => {
    const [selectedRowData, setSelectedRowData] = useState(null); 

    const user = useSelector(state => state.AppState.user);
    const boxDetails = useSelector(state => state.AppState.boxDetails.box);
    const dispatch = useDispatch();
    const token = localStorage.getItem('jwtToken') || null;

    const [callID, setCallID] = useState(false);
    const [svgModelOpen, setSvgModelOpen] = useState(false);
    const [svgData, setSvgDate] = useState(false);
    const [tooltipOpenSVG, setTooltipOpenSVG] = useState(false);
    const [tipPcapDownload, settipPcapDownload] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(1);
    const [isPcapDateValid, setPcapDateValid] = useState(true);

    const toggleSVGToolTip = () => setTooltipOpenSVG(!tooltipOpenSVG);
    const toggletipPcapDownload = () => settipPcapDownload(!tipPcapDownload);
    const realTimeActivityEnabled = getPermissionForComponent('realTimeActivityEnabled',user.permissionsGroup);


    const isUserPermitted =
      user?.role === 'superAdmin' ||
      (['companyGroupManager', 'companyGroupAdmin'].includes(user?.role));

    const onCdrImage = async () => {
      setIsLoading(true);

      const { _id } = boxDetails;

      const imageData = await dispatch(getAnalayticsImage(token, _id, callID));
      if (imageData) {
        setSvgDate(imageData);
        setSvgModelOpen(true)
      }

      setIsLoading(false);
    }

    const onCdrDownload = async () => {
      setIsLoading(true);
      const { _id } = boxDetails;

      await dispatch(downloadAnalayticsFile(token, _id, callID));
      setIsLoading(false);
    }

    return (
      <Modal isOpen={isOpen} style={{ maxWidth: '60%' }}>
        <ModalHeader className='cdrHeader' style={{ width: '100%' }}>{!isCdrLogs ? headText :
          <div className='cdrHeaderWrapper'>
            <Col md="6" lg="6" xs="1">
              <h5 className='modal-title' style={{ width: '100%' }}>{headText}</h5>
            </Col>
            <Col md="6" lg="6" xs="1">
              {isUserPermitted && !!cdrVoipMonLogs.results ?
                (<td className='d-flex justify-content-end' style={{ width: '100%' }}>
                  <AnalyticsIcon2
                    width={40}
                    height={40}
                    onClick={onCdrImage}
                    className='cursor-pointer analytics-icon-datagram '
                  id={`call-flow-svg`}
                  />
                  <Tooltip
                    placement={'top'}
                    isOpen={tooltipOpenSVG}
                    target={`call-flow-svg`}
                    toggle={toggleSVGToolTip}
                  >
                    Call Flow Diagram
                  </Tooltip>
                  {(realTimeActivityEnabled === 'write' || realTimeActivityEnabled === 'both') &&  
                    <>
                      <AnalyticsIcon3
                        width={40}
                        height={40}
                        onClick={onCdrDownload}
                        className='cursor-pointer analytics-icon'
                        id={`pcap-download-file`}
                      />
                      <Tooltip
                        placement={'top'}
                        isOpen={tipPcapDownload}
                        target={`pcap-download-file`}
                        toggle={toggletipPcapDownload}
                      >
                        Download PCAP
                      </Tooltip>
                    </>
                  }
                </td>) : <></>
              }
            </Col>
          </div>
        }</ModalHeader>
        <ModalBody>
          <div className="container">
            <Row>
              <Col lg={12} md={12} sm={6}>
                {!isCdrLogs ? (
                  <CdrAnalytics cdrAnalytics={cdrs} onSelectRow={setSelectedRowData}/>
                ) : (isLoading ? <LoadingIcon width={50} height={50} /> :
                  <VoipMonActivityLogs
                  cdrVoipMonLogs={cdrVoipMonLogs} 
                  svgData={svgData} 
                  svgModelOpen={svgModelOpen} 
                  setSvgModelOpen={setSvgModelOpen} 
                  setCallID={setCallID} 
                  activeTab={activeTab} 
                  setActiveTab={setActiveTab} 
                  setPcapDateValid={setPcapDateValid}
                  selectedRowData={selectedRowData}
                  />
                )}
              </Col>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button outline onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
        
      </Modal>
    );
  };

export default CdrAnalyticsModal;
